'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:webview:setMenus');
}

var _invoke = require('../invoke');

/**
 * 设置导航栏右侧按钮
 *
 * 目前支持 `icon`/`text` 两种类型的按钮
 *
 * 支持版本
 * + iHotel/5.8+
 *
 * @memberof webview
 * @static
 * @name setMenus
 * @param {Array} menus 按钮设置
 * @return {Undefined}
 * @example
 *  hbnb.webview.setMenus([{
 *      type: 'text',
 *      text: '确定',
 *      color: '#cccccc',
 *      callback: function() {console.log('clicked'); return false;}
 *  }, {
 *      type: 'icon',
 *      icon: 'url',
 *      callback: function() {console.log('clicked'); return false;}
 *  ]);
 */
module.exports = function(menus) {
    if (process.env.NODE_ENV !== 'production') {
        debug('menus is %j', menus);
    }

    _invoke('webview', 'set_navbar_menus', {
        menus: menus
    });
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/webview/set-menus.js
// module id = 666
// module chunks = 0